module.exports = __webpack_public_path__ + "console/img/machinecore_logo_small_final@2x.0d7393dd.png";